import { css } from 'styled-components';
import {
  TransitionDuration,
  TransitionTimingFunction,
} from '../../assets/BurgerMenu';

const MenuCSS = css`
  position: absolute;
  top: ${({ topOffset }) => topOffset + 'px'};
  right: 0;
  left: ${({ visible }) => (visible ? 0 : '100%')};
  visibility: ${({ visible }) => (visible ? 'visible' : 'hidden')};

  overflow: hidden;
  transition:
    left ${TransitionDuration} ${TransitionTimingFunction},
    visibility ${TransitionDuration};
`;

export default MenuCSS;
